import type { SVGProps } from 'react'
const LineChevronUpSmall = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			d="M17.72 15.28 12 9.56l-5.72 5.72-1.06-1.06 5.895-5.895a1.26 1.26 0 0 1 1.77 0l5.895 5.895z"
		/>
	</svg>
)
export { LineChevronUpSmall }
